import EnhancedModal from '../../../common/EnhancedModal/EnhancedModal';
import ImagePreview from '../ProductsPreviewSection/ImagePreview';
import { TruncatedText } from '../../../common';
import useIsMobile from '../../../../hooks/useIsMobile';
import { formatCurrency } from '../../../../utils/global';
import CartIcon from '../../../../assets/icons/CartIcon';
import DollarIcon from '../../../../assets/icons/DollarIcon';
import styles from '../ConfirmProducts/confirmProducts.module.css';
import ButtonComponent from '../../../common/button-component/button-component';

interface Props {
  open: boolean;
  onClose: () => void;
  products: any[];
  defaultCurrency: string;
}

export default function ViewProductsModal({ open, onClose, products, defaultCurrency }: Props) {
  const isMobile = useIsMobile();

  const totalItems = products?.length;
  const totalValue = products.reduce(
    (acc, product) => acc + (product?.productDetails?.productPrice || 0) * (product?.quantity || 1),
    0
  );

  return (
    <EnhancedModal
      open={open}
      onClose={onClose}
      title="Product Details"
      showBackButton
      handleBack={onClose}
      showCloseButton
      width={396}
      bodyClassName={`${isMobile ? 'px-4' : 'px-6'}`}
      footerClassName={`${isMobile ? 'p-4' : 'p-6'}`}
      footer={
        <ButtonComponent variant="secondary" onClick={onClose} fullWidth>
          <span className="text-sm">Go Back</span>
        </ButtonComponent>
      }
    >
      {products.map((product, i) => {
        const productDetails = product?.productDetails;
        const variantOptions = productDetails?.variantDetail;
        const options = Object.keys(variantOptions)?.map((option: any) => ({
          name: option,
          value: variantOptions[option],
        }));
        return (
          <div className={`${styles.singleProductPreview} border-default rounded`} key={i}>
            <ImagePreview
              imageUrl={productDetails?.productImage}
              name={productDetails?.productName}
              width={64}
              height={64}
            />
            <div className="w-full">
              <div className="w-full flex flex-between">
                <div className="text-sm font-medium text-default flex items-center gap-2">
                  <TruncatedText text={productDetails?.productName} maxLines={1} width={130} />
                  {!isMobile && (
                    <span className="text-sm font-normal">
                      {formatCurrency(Number(productDetails?.productPrice), defaultCurrency)}
                    </span>
                  )}
                </div>
              </div>
              {options?.length > 0 &&
                options?.map((option: any, index: number) => (
                  <p key={index} className={styles.variantOption}>
                    <span className={styles.variantOptionHeading}>{option?.name}:</span>{' '}
                    <span className={styles.variantOptionValue}>{option?.value || 'N/A'}</span>
                  </p>
                ))}
              {isMobile && (
                <span className={`font-normal  ${isMobile ? 'text-xs' : 'text-sm'}`}>
                  {formatCurrency(Number(productDetails?.productPrice), defaultCurrency)}
                </span>
              )}
            </div>
          </div>
        );
      })}

      <div className={styles.totalItemsContainer}>
        <div className="flex items-center gap-1">
          <div className={styles.totalItemsIcon}>
            <CartIcon color="var(--icon-default)" />
          </div>
          Total Items: <span className="text-default">{totalItems}</span>
        </div>
        <div className="flex items-center gap-1">
          <div className={styles.totalItemsIcon}>
            <DollarIcon color="var(--icon-default)" />
          </div>
          Total Value: <span className="text-default">{formatCurrency(totalValue, defaultCurrency)}</span>
        </div>
      </div>
    </EnhancedModal>
  );
}
